const terminate = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13m2.803 2.636 1.06 1.061L9.06 8l2.804 2.803-1.061 1.06L8 9.06l-2.803 2.804-1.06-1.061L6.94 8 4.136 5.197l1.061-1.06L8 6.94z"/></svg>',
};

export { terminate as default };
